import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadedDocumentMetadata } from 'src/app/models/uploaded-document-metadata';
import { environment } from 'src/environments/environment';
import { DocumentInterface } from './document.interface';

@Injectable({
  providedIn: 'root'
})
export class DocumentService implements DocumentInterface {

  public GB = 1073741824
  public MB = 1048576

  constructor(private httpClient: HttpClient) { }

  Upload(document, courseApprovalId, sectionName, previousVersionId, fileOffset, isLast: boolean = false, uploadId, exceedsThreshold: boolean = false, phaseId: number = -1, programStatusId: number,
       version: number = 0, documentStatus: number = 0, isSose: boolean = false): Observable<any> {
    let headers = new HttpHeaders()
    headers.set('Content-Type', 'multipart/form-data')
    const soseSuffix = isSose ? 'Sose' : '';
    return this.httpClient.post<any>(environment.apiBaseUrl + `DocumentToSharepoint/streamDocument${soseSuffix}/${courseApprovalId}/${sectionName}/${fileOffset}/${isLast}/?previousVersionId=${previousVersionId}&uploadId=${uploadId}&exceedsThreshold=${exceedsThreshold}&phaseId=${phaseId}&programStatusId=${programStatusId}&version=${version}&documentStatus=${documentStatus}`,
      document,
      {
        reportProgress: true,
        observe: 'events',
        headers: headers
      });
  }

  GetDocumentMetadatasByCourseApprovalIdAndSection(courseApprovalId, sectionName, phaseId, version): Observable<UploadedDocumentMetadata[]> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `Document/GetDocMetadata/${courseApprovalId}/${sectionName}/${phaseId}/${version}`)
  }

  GetDocumentMetadataBySoseApplicationId(soseApplicationId): Observable<UploadedDocumentMetadata[]> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `Document/GetDocumentMetadataBySoseApplicationId/${soseApplicationId}`)
  }

  DeleteDocumentMetadata(metadataId: string, isSose: boolean = false) {
    const soseSuffix = isSose ? 'Sose' : '';
    return this.httpClient.delete<boolean>(environment.apiBaseUrl + `Document/DeleteDocMetadata${soseSuffix}/${metadataId}`)
  }

  Download(metadataId: string, offset: number, version: number = 0) {
    const reqHeader = new HttpHeaders({ 'contentdisposition': 'Inline', });
    return this.httpClient.get(environment.apiBaseUrl + `DocumentToSharepoint/download/${metadataId}/${offset}/${version}`,
      { reportProgress: true, headers: reqHeader, responseType: 'blob', observe: 'response' });
  }

  GetFilesize(metadataId: string, version: number = 0): Observable<number> {
    return this.httpClient.get<number>(environment.apiBaseUrl + `DocumentToSharepoint/filesize/${metadataId}/${version}`, { reportProgress: true });
  }
}
